<template>
  <div class="setpassword-box show-flex-box-c show-flex-center" 
       @click.self="clickClosePop()" 
       v-if="isSetPasswordLogin">
    <div class="setpassword-total show-flex-box-r show-flex-center">
      <div class="setpassword-all show-flex-box-c">
        <!-- X图标 -->
        <em @click.self="clickClosePop()"></em>
        <dl class="setpassword-content show-flex-box-c">
          <dt class="select-setpassword-way show-flex-box-r">
            <ul class="select-setpassword-way-list show-flex-box-r">
              <li class="select-setpassword-way-item show-flex-box-c">
                <span>设置密码</span>
                <em></em>
              </li>
            </ul>
            <span @click="backBindPhone()">返回绑定手机</span>
          </dt>
          <dd class="account-box show-flex-box-c">
            <div class="account-content-info show-flex-box-c">
              <ul class="account-content-password-input show-flex-box-c">
                <li class="show-flex-box-r">
                  <em></em>
                  <span class="show-flex-box-r">
                    <input type="password" placeholder="请设置密码" v-model="passwrodLoginFrom.password">
                  </span>
                </li>
                <li class="show-flex-box-r">
                  <em></em>
                  <span class="show-flex-box-r">
                    <input type="password" placeholder="请确认密码" v-model="passwrodLoginFrom.secondPassword">
                  </span>
                </li>
              </ul>
            </div>
            <span class="show-flex-box-r">
              <span @click="submitChangePassword()">完成</span>
             </span>
          </dd>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
  import wx from 'weixin-js-sdk'
  import regex from "@/filter/regex";
  import { CountDown } from "@/../static/js/CountDown";
  // import {LoginUser} from "@/model/login_user.js";

  export default {
    name: "setPassword",
    data() {
      return {
        isSetPasswordLogin: false,
        passwrodLoginFrom:{
          password:'',  
          secondPassword:'',
        },
    };
    },
    components: {},
    mounted() {
  
    },
    methods: {
      colseSetPasswordWin: function(isShow) {
        this.isSetPasswordLogin = typeof(isShow) != "undefined" ? isShow : !this.isSetPasswordLogin;
      },
      backBindPhone: function() {
        this.closePopByType('backBindPhone');
      },
      clickClosePop: function() {
        this.closePopByType('close');
      },
      closePopByType: function(type) {
        this.colseSetPasswordWin(false);

        this.$emit('popShowStatusChange',{
          type: type,
          status: this.isSetPasswordLogin,
        });
      },
      submitChangePassword: function() {
        const isPassword = this.checkPasswordSame();

        if (isPassword) {
          this.submitNewPassword();
        }else{
          this.passwrodLoginFrom.password = '';
          this.passwrodLoginFrom.secondPassword = '';
        }
      },
      checkPasswordSame: function() {
        var status = true;
        if(this.passwrodLoginFrom.password == this.passwrodLoginFrom.secondPassword){
          status = true;
        }else{
          status = false;
          this.$message({
            showClose: true,
            message: "两次输入密码不一致",
            type: "error"
          });
        }
        return status;
      },
      submitNewPassword: function() {
        var params = {
          old_password: '1234567',
          password: this.passwrodLoginFrom.password
        };

        this.$client.updatePersonalData(params)
          .then(res => {
            console.log(res);
            if (res.code == 200) {
              this.setPasswordSuccess();
            }
          })
          .catch(err => {
            this.$message({
              showClose: true,
              message: err.data.message,
              type: "error"
            });
          });
      },
      setPasswordSuccess: function() {
        this.$message({
          showClose: true,
          message: "设置成功",
          type: "success"
        });

        this.isSetPasswordLogin = false;
        this.$emit("updata-bind-success");
        this.resetFrom();
      },
    }
  };

</script>
<style lang="less" scoped>
  .setpassword-box{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 999;
    background: rgba(0, 0, 0, 0.4);
    .setpassword-total{
      width:560px;
      padding: 30px 0px 60px 0px; 
      background:#FFFFFF;
      border-radius:8px;
      position: absolute;
      .setpassword-all{
        width: 506px;
        height: 100%;
        align-items: flex-end;
        padding-left: 22px;
        >em{
          display: block;
          width: 22px;
          height: 22px;
          background: url("../../assets/login/close_arrow_icon.png") no-repeat center center;
          background-size: 22px 22px;
          margin-bottom: 18px;
          flex-shrink: 0;
          cursor: pointer;
        }
        >dl{
          width: 100%;
          >dt{
            padding-right: 23px;
            align-items: flex-end;
            margin-bottom: 30px;
            >ul{
              width: 100%;
              align-items: center;
              >li{
                align-items: center;
                margin-right: 25px;
                cursor: default;
                >span{
                  font-size:24px;
                  font-family:PingFangSC-Regular,PingFang SC;
                  font-weight:400;
                  color:#333333;
                  line-height:33px;
                  white-space: nowrap;
                  flex-shrink: 0;
                  margin-bottom: 5px;
                }
               >em{
                  width:35px;
                  height:5px;
                  background:#CB1309;
                  border-radius:3px;
               }

              }
            }
            >span{
              font-size:15px;
              font-family:PingFangSC-Regular,PingFang SC;
              font-weight:400;
              color:#333333;
              line-height:21px;
              white-space: nowrap;
              flex-shrink: 0;
              margin-bottom: 10px;
              cursor: pointer;
            }
          }
          .account-box{
            width: 100%;
            .account-content-info{
              padding-right: 23px;
              .account-content-password-input{
                width: 100%;
                >li{
                  padding: 0px 15px;
                  height:60px;
                  background:#FAFAFA;
                  box-shadow:3px 3px 3px 0px #F4F4F9;
                  border-radius:4px;
                  border:1px solid #EEEEEF;
                  margin-bottom: 20px;
                  align-items: center;
                  cursor: pointer;
                  >em{
                    width: 20px;
                    height: 20px;
                    display: block;
                    background: url(../../assets/login/password_icon.png) no-repeat center center;
                    background-size: 100% 100%;
                    flex-shrink: 0;
                  }
                  >span{
                    flex-grow: 1;
                    margin-left: 20px;
                    align-items: center;
                    >input{
                      width: 100%;
                      height: 100%;
                      font-size:16px;
                      font-family:PingFangSC-Medium,PingFang SC;
                      font-weight:500;
                      color:#333333;
                      line-height:22px;
                    }
                  }
                }
                >li:hover{
                  padding: 0px 15px;
                  height:60px;
                  background:rgba(203,19,9,0.04);
                  box-shadow:3px 3px 3px 0px rgba(203,19,9,0.1);
                  border-radius:4px;
                  border:1px solid rgba(203,19,9,1);
                }
              }
           
            }
            >span{
              padding-right: 23px;
              margin-top: 10px;
              >span{
                cursor: pointer;
                width: 100%;
                height:60px;
                background:#CB1309;
                box-shadow:0px 2px 4px 0px #CB1309;
                border-radius:4px;
                line-height: 60px;
                text-align: center;
                font-size:16px;
                font-family:PingFangSC-Medium,PingFang SC;
                font-weight:500;
                color:rgba(255,255,255,1);
              }
              
            }
          }
        }
      }
    }

  }

</style>



// WEBPACK FOOTER //
// src/views/login/set_password.vue